import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const getDomains = (onCompleteFunc) => {

    const url = Globals.APIFolder + '/domains' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const createNewDomain = ( formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/domain' ;

    getDataWithPromise(url, 'POST', formData).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const updateDomainDetails = ( domain_id, formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/domain/' + domain_id ;

    // This update is a post for some reason.
    getDataWithPromise(url, 'POST', formData).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getDomainDetails = ( domain_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/domain/' + domain_id + '?include-organisations';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}